import img1 from './100001.jpg.jpeg'
import img2 from './100002.jpg.jpeg'
import img3 from './100003.jpg.jpeg'
import img4 from './100004.jpg.jpeg'

export const img = [img1,img2,img3,img4]